import { getEwsRequestString } from 'owa-datetime';
import { isFolderPaused, listViewStore, TableView } from 'owa-mail-list-store';
import constant from 'owa-service/lib/factory/constant';
import fieldURIOrConstantType from 'owa-service/lib/factory/fieldURIOrConstantType';
import isLessThanOrEqualTo from 'owa-service/lib/factory/isLessThanOrEqualTo';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import restrictionType from 'owa-service/lib/factory/restrictionType';

/**
 * Gets the restrictions for the findConversation call based upon the current state of the table
 * @param tableView tableView where the rows are being fetched
 */
export function getFindConversationsRestrictions(tableView: TableView) {
    let dateTimeRestriction;

    /**
     * If the folder for this table is in paused state add the date time restriction so that
     * newer items than the paused time shall not be fetched
     */
    if (isFolderPaused(tableView.tableQuery.folderId)) {
        const restriction = isLessThanOrEqualTo({
            Item: propertyUri({ FieldURI: 'ConversationLastDeliveryTime' }),
            FieldURIOrConstant: fieldURIOrConstantType({
                Item: constant({
                    Value: getEwsRequestString(listViewStore.inboxPausedDateTime),
                }),
            }),
        });

        dateTimeRestriction = restrictionType({
            Item: restriction,
        });
    }

    return dateTimeRestriction;
}
